import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment-timezone";
import classNames from "classnames";
import { createColumnHelper } from "@tanstack/react-table";
import { dateTimeFormat } from "../../../../utils/helpers/date";

const columnsHelper = createColumnHelper();

export const useColumns = ({ dateFormat }) => {
    const { t } = useTranslation();

    return useMemo(() => [
        columnsHelper.accessor("type", {
            header: t("type"),
            cell: (info) => {
                const value = info.getValue();
                return t(value.toLowerCase());
            }
        }),
        columnsHelper.accessor("startDate", {
            header: t("start-date"),
            cell: (info) => {
                const value = info.getValue();
                return value &&
                    dateTimeFormat(moment(value), dateFormat)
            }
        }),
        columnsHelper.accessor("endDate", {
            header: t("end-date"),
            cell: (info) => {
                const value = info.getValue();
                return value &&
                    dateTimeFormat(moment(value), dateFormat)
            }
        }),
        columnsHelper.accessor("total", {
            header: t("total"),
            cell: (info) => {
                const value = info.getValue();
                return Number(value).toFixed(2);
            }
        }),
    ], [t, dateFormat]);
};
